import React, { Component } from 'react';
import _ from 'lodash';
import { WithStyles, MenuItem, Checkbox, ListItemText, InputAdornment, ListSubheader } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Card, CardContent, Typography } from '@material-ui/core';
import { MyPATDialog, MyPATSelect, MyPATTextField } from '../../common';
import Button from '@material-ui/core/Button';
import { connect } from "react-redux";
import courseService from "../services/courseService";
import { showMsg } from '../actions/loaderAlert';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';
import { setCourseData } from "../actions/courseSetData"
import { styles } from '../styling/component/CreateCourseModals'
import { KeyValue, OnlyKey, AdminDetails } from '../modals/CommonModels';
import Date from '@material-ui/icons/DateRange';
import { Remove } from '@material-ui/icons';
import moment from 'moment';
import cx from 'classnames';

var fileData = '';
const TargetYear = [
	'Choose Target Year',
	'2022',
	'2021',
	'2020',
	'2019',
];
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	anchorOrigin: {
		vertical: 'bottom',
		horizontal: 'center',
	},
	transformOrigin: {
		vertical: 'top',
		horizontal: 'center',
	},
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

interface CreateCourseModalsProps extends WithStyles<typeof styles> {
	createContentOpen: Boolean,
	createContentCloseHandler: Function,
	createContentGoals: KeyValue[],
	showMsg: (msg: string, vari: string) => void,
	setCourseData: Function;
}

interface CreateCourseModalsStates {
	createContentStep2Open: Boolean,
	Course: string,
	Target_year: string,
	Goals: string,
	Start_Date: string,
	End_Date: string,
	Course_Admin: any,
	title: string,
	description: string,
	createContentStep2Data: {
		type: string,
		typeName: string,
	},
	adminArr: AdminDetails[],
	selectedGoal: String[],
	fileData: any,
	isOpen: boolean
}


class CreateCourseModals extends Component<CreateCourseModalsProps, CreateCourseModalsStates> {
	constructor(props: CreateCourseModalsProps) {
		super(props);
		this.state = {
			isOpen: false,
			createContentStep2Open: false,
			Course: '',
			Target_year: '',
			Goals: '',
			Start_Date: '',
			End_Date: '',
			Course_Admin: [],
			title: '',
			description: '',
			createContentStep2Data: {
				type: '',
				typeName: '',
			},
			adminArr: [],
			selectedGoal: [],
			fileData: "",

		};

		this.createContentStep2CloseHandler = this.createContentStep2CloseHandler.bind(this);
		this.navigateToCourseDetail = this.navigateToCourseDetail.bind(this)
	};

	componentWillMount = () => {
		var self = this;
		courseService.getAdmins().then((responseData: AdminDetails[]) => {
			if (!_.isEmpty(responseData)) {
				self.setState({
					adminArr: responseData
				})
			}
		});
	}

	componentDidUpdate(prevProps: any) {
		// Typical usage (don't forget to compare props):
		if (this.props.createContentOpen !== prevProps.createContentOpen) {
			this.setState({
				Course_Admin: [],
				selectedGoal: [],
				fileData: "",
				Course: '',
				Target_year: '',
				Start_Date: '',
				End_Date: '',
				title: '',
				description: '',
			})
		}
	}

	createContentStep2CloseHandler = (event: any) => {
		this.setState({
			createContentStep2Open: false
		});
	};

	handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
	}

	handleChange = (e: { target: { name: string, value: string } }) => {
		var { name, value } = e.target;
		if (name == "Target_year") {
			this.setState({ selectedGoal: [] })
		}

		this.setState({ [name]: value } as any);
	}

	handleFile = (event: any) => {
		this.setState({ fileData: event.target.files[0] } as any);
	};



	handleClick = (e: any) => {
		e.preventDefault();
		var self = this;
		var formData = new FormData();
		formData.append("name", this.state.Course);
		formData.append("targetYear", this.state.Target_year);
		formData.append("goals", this.state.selectedGoal.join(","));
		formData.append("startDate", this.state.Start_Date);
		formData.append("expiryDate", this.state.End_Date);
		formData.append("admins", this.state.Course_Admin.join(","));
		formData.append("title", this.state.title);
		formData.append("description", this.state.description);
		var file = this.state.fileData;
		if (file != "") {
			formData.append("file", file);
		}
		//courseService.createCourse(formData)

		courseService.createCourse(formData).then((responseData: any) => {
			if (!_.isEmpty(responseData) && responseData.status == 200) {
				self.props.createContentCloseHandler()
				self.setState({
					createContentStep2Open: false,
				});
				let _data = responseData.data;
				self.navigateToCourseDetail(_data._id)
			}
		});
	}

	navigateToCourseDetail(_id: string) {
		var self = this;
		courseService.getPackageDetails(_id).then((responseData: any) => {
			self.props.setCourseData(responseData);
			setTimeout(function () {
				window.location.href = `/course/detail/${_id}`;
			}, 200)
		});


	}

	handleChangeGoal(event: any) {
		if (event.target.value.includes(undefined)) {
			this.setState({ isOpen: false })
		}

		this.setState({ selectedGoal: event.target.value.filter((val: String) => val !== undefined) });
	};
	handleClose = () => {
		this.setState({ isOpen: false })
	};

	handleOpen = () => {
		this.setState({ isOpen: true })
	};


	handleChangeAdmins(event: any) {
		this.setState({ Course_Admin: event.target.value });
	};

	render() {
		const { classes, createContentOpen, createContentCloseHandler } = this.props;
		const { createContentStep2Open, createContentStep2Data, Course_Admin, adminArr, selectedGoal, fileData, Target_year } = this.state;

		const otherDialogProps = {
			fullWidth: true,
			maxWidth: 'md',
			scroll: 'body',
		};
		let tempGoalArr = this.props.createContentGoals || [];
		let goalArr = tempGoalArr.filter(function (v: any) {
			return v.targetYear == Target_year
		})

		return (
			<>
				<MyPATDialog
					dialogHeading={<Typography className={classes.headerLeft}>Course Basic Details <span className={classes.redStar}>*</span></Typography>}
					dialogOpen={createContentOpen}
					otherDialogProps={otherDialogProps}
					dialogHasActions={false}
					onDialogClose={createContentCloseHandler}
				>
					<form onSubmit={this.handleSubmit} >
						<Grid container>
							<Grid item xs={6}>
								<Typography variant="h6">Course Name</Typography>
								<MyPATTextField
									inputId="Course"
									name="Course"
									fullWidthControl
									placeholder="Enter Course"
									onChange={this.handleChange}
									inputProps={{
										required: true,
										minLength: 3
									}}

								/>
							</Grid>
							<Grid item xs={6} className={classes.dropDownItems}>
								<Typography variant="h6">Target Year</Typography>
								<MyPATSelect
									className={classes.selectSection}
									label=""
									inputId="Target_year"
									name="Target_year"
									defaultValue=""
									value={this.state.Target_year}
									onChange={this.handleChange}
									inputProps={{
										required: true
									}}
								>

									{TargetYear.map((name,nameIndex) => (
										<option key={`name ${nameIndex}`} value={name} >
											{name}
										</option>
									))}
								</MyPATSelect>
							</Grid>
							<Grid item xs={12} className={classes.selectGoale}>
								<Typography variant="h6">Goals</Typography>
								<FormControl className={classes.formControl}>
									<Select
										style={{ width: '100%' }}
										className={cx(`${classes.input} `)}
										multiple
										open={this.state.isOpen}
										onClose={this.handleClose}
										onOpen={this.handleOpen}
										value={selectedGoal}
										disableUnderline={true}
										onChange={this.handleChangeGoal.bind(this)}
										defaultValue="Select"
										placeholder="Select Goals"
										input={<Input id="select-multiple-chip" />}
										renderValue={(selected: any) => (
											<div className={classes.chips}>
												{selected.map((value: any, valueIndex: number) => (
													<Chip key={`value ${valueIndex}`} label={goalArr.map((s: any) => (s._id == value ? s.name + " - " + s.targetYear : ""))} className={classes.chip} />
												))}
											</div>
										)}
										// MenuProps={MenuProps}
										MenuProps={{
											getContentAnchorEl: null,
											anchorOrigin: {
												vertical: "bottom",
												horizontal: "left",
											}
										}}
									>

										<ListSubheader disableSticky={false} inlist inputMode="false" >
											<button
											>Ok</button>
										</ListSubheader>


										{
											goalArr.map(function (v: any, i: any) {
												return <MenuItem key={`${v._id} ${i}`} value={v._id} style={{ textTransform: 'capitalize' }}>
													<Checkbox checked={selectedGoal.indexOf(v._id) > -1} />
													<ListItemText primary={v.name + " " } />
												</MenuItem>
											})
										}
									</Select>
								</FormControl>
								<Grid item xs={12} className={classes.selectGoale}>
									<Grid container>
										<Grid item xs={6}>
											<Typography variant="h6">Start Date</Typography>
											<MyPATTextField
												id="datetime-local"
												name="Start_Date"
												type="date"
												value={this.state.Start_Date}
												variant="outlined"
												fullWidth margin="dense"
												style={{ width: '454px' }}
												onChange={this.handleChange}
												InputLabelProps={{
													shrink: true,
													minLength: 3
												}}
												inputProps={{
													required: true,
													min: moment().format('YYYY-MM-DD')
												}}
												startAdornment={
													<InputAdornment position="start">
														<Date classes={{ root: classes.dateIcon }} />
													</InputAdornment>
												}
											/>
										</Grid>
										<Grid item xs={6} style={{ paddingLeft: '15px' }}>
											<Typography variant="h6">End Date</Typography>
											<MyPATTextField
												id="datetime-local"
												type="date"
												name="End_Date"
												value={this.state.End_Date}
												variant="outlined"
												fullWidth margin="dense"
												onChange={this.handleChange}
												style={{ width: '440px' }}
												InputLabelProps={{
													shrink: true,
												}}
												inputProps={{
													required: true,
													min: moment(this.state.Start_Date).format('YYYY-MM-DD')
												}}
												startAdornment={
													<InputAdornment position="start">
														<Date classes={{ root: classes.dateIcon }} />
													</InputAdornment>
												}
											/>
										</Grid>
									</Grid>
								</Grid>

							</Grid>
							<Grid item xs={12} className={classes.selectGoale}>
								<Grid container>
									<Grid item xs={6} >
										<Typography variant="h6">Course Admin</Typography>
										{<Select
											style={{ width: '100%' }}
											className={classes.input}
											multiple
											value={Course_Admin}
											disableUnderline={true}
											onChange={this.handleChangeAdmins.bind(this)}
											defaultValue="Select"
											input={<Input id="select-multiple-chip" />}
											renderValue={(selected: any) => (
												<div className={classes.chips}>
													{selected.map((value: any, index: number) => (
														<Chip key={`value ${index}`} label={adminArr.map((s: any) => (s._id == value ? s.fullName : ""))} className={classes.chip} />
													))}
												</div>
											)}
											MenuProps={{
												anchorOrigin: {
													vertical: 'bottom',
													horizontal: 'center',
												},
												transformOrigin: {
													vertical: 'top',
													horizontal: 'center',
												}
											}}
										>
											{
												adminArr.map(function (v: any, i: any) {
													return <MenuItem key={`${v._id} ${i}`} value={v._id} style={{ textTransform: 'capitalize' }}>
														<Checkbox checked={Course_Admin.indexOf(v._id) > -1} />
														<ListItemText primary={v.fullName} />
													</MenuItem>
												})
											}
										</Select>}


									</Grid>
									<Grid item xs={6} style={{ paddingLeft: '15px' }}>
										<Typography style={{ marginBottom: '10px' }} variant="h6">Course Icon</Typography>
										<input name="file" onChange={this.handleFile}
											accept="image/*"
											style={{ display: 'none' }}
											id="raised-button-file"
											multiple
											type="file"
										/>
										<label htmlFor="raised-button-file">
											{
												fileData == ""
													?
													<div style={{ display: 'contents' }} className={classes.selectFiles}>Upload Icon</div>
													:
													<div className={classes.selectFiles} style={{ display: 'contents' }}> Upload Icon<span style={{ color: 'grey' }}> {fileData.name}</span></div>
											}

										</label>
									</Grid>
								</Grid>
							</Grid>

							<Grid item xs={12} className={classes.selectGoale}>
								<Grid container>
									<Grid item xs={6}>
										<Typography variant="h6" gutterBottom>Meta Title</Typography>
										<MyPATTextField
											inputId="title"
											name="title"
											fullWidthControl
											placeholder="Enter meta title"
											onChange={this.handleChange}
											inputProps={{
												required: true,
												minLength: 3
											}}

										/>
									</Grid>
									<Grid item xs={6}>
										<Typography variant="h6" style={{ marginLeft: '18px' }} gutterBottom>Meta Description</Typography>
										<MyPATTextField
											style={{ marginLeft: '18px' }}
											inputId="description"
											name="description"
											fullWidthControl
											placeholder="Enter meta description"
											onChange={this.handleChange}
											inputProps={{
												required: true,
												minLength: 3
											}}

										/>
									</Grid>
								</Grid>
							</Grid>
						</Grid>

						<Grid item xs={12}>
							<Button style={{ marginTop: '1px' }}
								variant="contained"
								type="submit"
								color="primary"
								className={classes.btnAlign}
								onClick={this.handleClick}
							>
								Create Course
									</Button>
						</Grid>
						<br />
						<br />
					</form>
				</MyPATDialog>
				{
					createContentStep2Open && (
						<MyPATDialog
							dialogHeading={createContentStep2Data.typeName}
							dialogOpen={createContentStep2Open}
							otherDialogProps={otherDialogProps}
							dialogHasActions={false}
							onDialogClose={this.createContentStep2CloseHandler.bind(this)}
							onDialogBack={this.createContentStep2CloseHandler.bind(this)}
						>
							<Grid container
								spacing={_.isEqual(createContentStep2Data.type, 'createQuestion') ? 16 : 32}
								justify="space-around"
								className={classes.createDialogWrapper}
							>
								{
									// @ts-ignore
									_.map(step2Types[createContentStep2Data.type], (stepData, stepDataIndex) => (
										<Grid item
											sm={_.isEqual(createContentStep2Data.type, 'createQuestion') ? 4 : 6}
											key={`${stepData.type} ${stepDataIndex}`}
										>
											<Card className={classes.cardRoot}>
												<CardContent className={classes.cardContentRoot}>
													<img
														alt={stepData.typeName}
														src={`/assets/img/mylibrary/${stepData.imgName}`}
														className={classes.cardImage}
													/>
													<Typography variant="h5">
														{
															stepData.typeName
														}: string
											</Typography>
												</CardContent>
											</Card>
										</Grid>
									))
								}
							</Grid>
						</MyPATDialog>
					)
				}
			</>
		)
	}
};

const mapDispatchToProps = (dispatch: any) => {
	return {
		showMsg: showMsg,
		setCourseData: setCourseData
	}
};


// @ts-ignore
export default withStyles(styles)(connect(null, mapDispatchToProps)(CreateCourseModals));
//export default withStyles(styles)(CreateCourseModals);